import dayjs from 'dayjs';
import { CreditAction } from '@monorepo/types';

export const formatAmount = (amount: number, action?: CreditAction) => {
  const formattedAmount = `$${Math.abs(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  if (!action) {
    return formattedAmount;
  }

  return action === CreditAction.Deduct
    ? `-${formattedAmount}`
    : formattedAmount;
};

export const formatDate = (date: Date) => {
  return dayjs(date).format('DD.MM.YY HH:mm');
};

export const getAmountColor = (
  action: CreditAction,
  palette: { error: { main: string }; success: { main: string } },
) => {
  return action === CreditAction.Deduct
    ? palette.error.main
    : palette.success.main;
};
